import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { productsApi } from "./Reducer/products";
import { authApi } from "./Reducer/auth";
import userReducer from "./slices/userSlice";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { settingsApi } from "./Reducer/settings";
import { contactSupportApi } from "./Reducer/contactSupport";
import { giveawayApi } from "./Reducer/giveaway";
import { giveawayAdsApi } from "./Reducer/giveawayAds";
import { clientApi } from "./Reducer/client";
import { notificationPrefernceApi } from "./Reducer/notificaiton-preference";
import { fileApi } from "./Reducer/file";
import { categoryApi } from "./Reducer/category";

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['user'],
};

// Create a persisted reducer for the user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer);

// Create the Redux store with the persisted reducer for the user slice
export const store = configureStore({
  reducer: {
    [productsApi.reducerPath]: productsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [contactSupportApi.reducerPath]: contactSupportApi.reducer,
    [giveawayApi.reducerPath]: giveawayApi.reducer,
    [giveawayAdsApi.reducerPath]: giveawayAdsApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [notificationPrefernceApi.reducerPath]: notificationPrefernceApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer, // Add the category API reducer
    // [userApi.reducerPath]: userApi.reducer,
    user: persistedUserReducer, // Use the persisted user reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
      },
    }).concat(productsApi.middleware, authApi.middleware, settingsApi.middleware, contactSupportApi.middleware, giveawayApi.middleware, giveawayAdsApi.middleware, clientApi.middleware,
      fileApi.middleware,
      notificationPrefernceApi.middleware,
      categoryApi.middleware,
      // userApi.middleware
    ),
});

// Initialize Redux Persist
export const persistor = persistStore(store);

// Setup listeners
setupListeners(store.dispatch);
